import { SITE, WA_DEFAULT } from "../../lib/site";
import { LogoMark } from "./Logo";

const LINKS = [
    { label: "Classi", href: "#classi" },
    { label: "Metodo", href: "#metodo" },
    { label: "Prezzi", href: "#prezzi" },
    { label: "Lo Studio", href: "#studio" },
    { label: "Contatti", href: "#contatti" },
];

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-ink px-5 pb-10 pt-20 text-white sm:px-8">
            <div className="mx-auto max-w-6xl">
                <div className="flex flex-col justify-between gap-12 md:flex-row">
                    <div>
                        <div className="flex items-center gap-4">
                            <LogoMark className="h-10 w-10" />
                            <span className="text-3xl font-light uppercase tracking-[0.35em]">Kore</span>
                        </div>
                        <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-white/60">
                            Studio Pilates a Cernobbio, Lago di Como. Reformer e
                            matwork in piccoli gruppi, con la cura di una volta.
                        </p>
                    </div>

                    <div className="flex gap-16">
                        <div>
                            <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-white/40">
                                Esplora
                            </p>
                            <ul className="mt-5 space-y-3">
                                {LINKS.map((l) => (
                                    <li key={l.href}>
                                        <a
                                            href={l.href}
                                            data-testid={`footer-link-${l.href.slice(1)}`}
                                            className="text-sm font-light text-white/70 transition-colors hover:text-white"
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-white/40">
                                Contatti
                            </p>
                            <ul className="mt-5 space-y-3 text-sm font-light text-white/70">
                                <li>{SITE.address}</li>
                                <li>
                                    <a href={SITE.phoneHref} className="transition-colors hover:text-white">
                                        {SITE.phone}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={WA_DEFAULT}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="transition-colors hover:text-white"
                                    >
                                        WhatsApp {SITE.whatsappDisplay}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-[10px] font-medium uppercase tracking-[0.2em] text-white/40 sm:flex-row">
                    <p>© 2026 Kore Studio Pilates — Cernobbio, Lago di Como</p>
                    <p>Lun—Dom 6:15–20:00</p>
                </div>
            </div>
        </footer>
    );
}
